import {useState, useEffect} from "react";

function ContentBlocks() {
    const [blocks, setBlocks] = useState([]);
    const [section, setSection] = useState("null");

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/content-blocks`)
        .then((res) => res.json())
        .then((data) => {
            setBlocks(data);
            if (data.length > 0) setSection(data[0].parent);
        });
    }, []);

    const sections = [...new Set(blocks.map((block) => block.parent))];
    const fields = blocks.filter((block) => block.parent === section);

    function handleChange(id, value) {
        setBlocks(blocks.map((block) => (block.id === id ? {...block, value} : block)));
    }

    function handleSave() {
        fetch(`${process.env.REACT_APP_API_URL}/api/content-blocks`, {
            method: "PUT",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify(fields.map((block) => ({id: block.id, value: block.value}))),
        }).then(() => alert("Saved"));
    }

    return (
        <div className="content-container">
            <div className="content-header">
                <h1>Content Blocks</h1>
            </div>

            <div className="content-section">
                {sections.map((sec) => (
                    <button key={sec} 
                    className={`content-tab ${section === sec ? "active" : ""}`}
                    onClick={() => setSection(sec)}>
                        {sec}
                    </button>
            ))}
        </div>

        
        <div className="page-content">
            {fields.map((f) => (
                <div key={f.id} className="content-field">
                    <label className="content-label">{f.label}</label>
                    <textarea
                        className="content-textarea"
                        value={f.value}
                        onChange={(e) => handleChange(f.id, e.target.value)}
                        rows={4}
                    />
                </div>
            ))}
        </div>            

        <div className="edit-action">
                <button className="primary-btn" onClick={handleSave}>Save Changes</button>
        </div>
    </div>
    );
}

export default ContentBlocks;